import * as React from "react";

function SvgLogout({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M24 24H0V0h24z" />
        <path
          fill="currentColor"
          d="M10.457 5.17a2.756 2.756 0 011.287 2.144l.006.189V18.25H15a1.25 1.25 0 001.244-1.122L16.25 17v-1a.75.75 0 011.493-.102l.007.102v1a2.75 2.75 0 01-2.582 2.745L15 19.75h-3.272c-.238 1.886-2.33 2.987-4.032 2.063l-.153-.09-4-2.5a2.751 2.751 0 01-1.287-2.143l-.006-.189V5.003c0-1.59 1.287-2.722 2.696-2.753H15a2.75 2.75 0 012.745 2.582L17.75 5v1a.75.75 0 01-1.493.102L16.25 6V5a1.25 1.25 0 00-1.122-1.244L15 3.75H8.184l2.273 1.42zM5.663 3.944a1.25 1.25 0 00-1.907.94l-.006.12v11.888c0 .384.175.743.471.978l.116.082 4 2.5a1.25 1.25 0 001.907-.938l.006-.121V7.503c0-.384-.175-.743-.471-.978l-.116-.082-4-2.5zm13.783 4.454l.084.073 2 2c.037.037.07.077.097.119l.044.076.007.013a.752.752 0 01.072.322l-.002.057-.013.09-.029.107-.039.089-.029.051-.044.064-.064.072-2 2a.749.749 0 01-1.133-.976l.073-.084.718-.72H15a.75.75 0 01-.102-1.493L15 10.25h4.189l-.72-.72a.75.75 0 01-.072-.976l.073-.084a.75.75 0 01.976-.073z"
        />
      </g>
    </svg>
  );
}

export default SvgLogout;
